import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, Optional, PLATFORM_ID, Renderer2, ViewChild } from '@angular/core';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { Response } from 'express';
import { removeUrlQueryParam } from '@techmore/global';
import { ServerConfigService } from '../../../share/service/server-config.service';
import { TemplateService } from '../../../web-generator/template-generator/service/template.service';
import { ITRISearchFilterParam, SUBJECT_OPTIONS } from '../../../data-search/entity/itri-filter-search-param';
import { of, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { AutoCompleteOptionsComponent } from '../../../share/component/auto-complete-options/auto-complete-options.component';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from '../../../web-generator/generator-env-token';

@Component({
  selector: 'app-not-found2',
  templateUrl: './not-found2.component.html',
  styleUrls: ['./not-found2.component.scss']
})
export class NotFound2Component implements OnInit {
  siteInfo: any;
  /** 是瀏覽器端渲染 */
  isBrowser: boolean;
  /** 是網站根路徑的404頁 */
  isRoot404 = true;
  /** 首頁路徑 */
  homePath: string;
  @ViewChild('skACO', {static: false}) skACO: AutoCompleteOptionsComponent;
  readonly SUBJECT_OPTIONS = SUBJECT_OPTIONS;
  /** 分類 */
  searchSubject: string;
  /** 關鍵字 */
  searchKeyword: string;
  /** 關鍵字變化通知器 */
  protected searchKeyword$ = new Subject<string>();
  /** 關鍵字檢索選項 */
  keywordsOptions: string[] = [];
  /** 查詢資料表單即時篩選項目參數 */
  searchFilter: ITRISearchFilterParam = {};
  get hasAnySearchFilter() { return Object.keys(this.searchFilter).length; }
  /** 關鍵字檢索訂閱 */
  private filterOptionSubc: Subscription;
  
  constructor(
    @Inject(PLATFORM_ID) protected platformId: object,
    @Optional() @Inject(RESPONSE) protected response: Response,
    private serverConfigService: ServerConfigService,
    private templateService: TemplateService,
    private render: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    protected router: Router,
    protected route: ActivatedRoute,
    protected http: HttpClient,
    @Inject(GENERATOR_ENV_TOKEN) protected generatorEnv: GeneratorEnv,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    if (!this.isBrowser) {
      this.response.status(404);
    }
    this.isRoot404 = this.serverConfigService.pathname.split('/').length === 2;
    if (this.isRoot404) {
      const newTitle = `Page not found｜${this.templateService.getSiteName()}`;
      this.templateService.setWebTitle({ title: newTitle, desc: 'Page not found', image: '' });
    }
    this.homePath = `/${this.serverConfigService.lang}`;

    this.render.setAttribute(this.document.head.querySelector('link[rel="canonical"]'), 'href', removeUrlQueryParam(this.serverConfigService.getCurrentUrl()));
    this.render.setAttribute(this.document.head.querySelector('meta[property="og:url"]'), 'content', removeUrlQueryParam(this.serverConfigService.getCurrentUrl()));
    this.render.setAttribute(this.document.head.querySelector('meta[name="twitter:url"]'), 'content', removeUrlQueryParam(this.serverConfigService.getCurrentUrl()));
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.filterOptionSubc = this.searchKeyword$.pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap(value => {
          if (value) {
            value = value.trim();
            const body = new URLSearchParams();
            body.set('top', '10');
            if (value) { body.set('q', value); }
            return this.http.post<{ input: string; output: {[key: string]: number}[]; }>(`${this.generatorEnv.itriAutoCompleteApiHost}/v2/autocomplete`, body.toString(), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              }
            });
            // return of(( { input: value, output: [{'戰爭館': 12}, {"第二次世界大戰": 50}]} as { input: string; output: {[key: string]: number}[]; } ));
          } else {
            return of(( { input: value, output: []} as { input: string; output: {[key: string]: number}[]; } ));
          }
        }),
        map(v => {
          return v.output.map(v2 => Object.keys(v2)[0]);
        }),
      ).subscribe(options => {
        this.keywordsOptions = options;
      });
    }
  }

  ngOnDestroy(): void {
    if (this.filterOptionSubc) {
      this.filterOptionSubc.unsubscribe();
      delete this.filterOptionSubc;
    }
  }
  
  /** 當關鍵字詞改變 */
  onKeywordChange(value: string) {
    this.searchKeyword$.next(value);
  }

  /** 當關鍵字輸入框聚焦 */
  onFocusSearchKeywordInput() {
    this.skACO.isShowOptions = true;
  }

  /** 選取數位物件類型 */
  selectFormat(format: string) {
    if (this.searchFilter.format !== format) {
      this.searchFilter.format = format;
    }
  }

  /** 全選所有數位物件類型 */
  selectFormatAll() {
    if (this.searchFilter.format) {
      this.searchFilter.format = undefined;
    }
  }

  /** 點擊放大鏡按鈕做查詢 */
  onClickSearch(e?: UIEvent) {
    if (e) { e.preventDefault(); }
    const params: any = {};
    const query: any = {};
    if (this.searchKeyword) {
      params.keyword = this.searchKeyword;
    }
    if (this.searchSubject) {
      query.subject = this.searchSubject;
    }
    if (this.hasAnySearchFilter) {
      Object.assign(query, this.searchFilter);
    }
    if (Object.keys(query).length) {
      params.query = JSON.stringify(query);
    }

    this.router.navigate([this.homePath, 'datasearch'], {
      queryParams: params,
      queryParamsHandling: 'merge',
      relativeTo: this.route,
    });
  }
}
